import zIndex from "@mui/material/styles/zIndex";
import { color } from "framer-motion";

export const tripDetailsPage = {
  loadingBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  errorBox: {
    padding: 3,
  },
  wrapper1D: {
    padding: "16px",
    width: "100%",
  },
  wrapper1M: {
    width: "100%",
  },
  headerWrapperD: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    columnGap: "16px",
    marginTop: "18px",
    flexWrap: "wrap",
  },
  headerWrapperM: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
    columnGap: "16px",
    marginTop: "18px",
    flexWrap: "wrap",
  },
  subheaderRightD: {
    display: "flex",
    flexDirection: "column",
    columnGap: "16px",
    justifyContent: "center",
    alignItems: "flex-end",
    rowGap: "16px",
  },
  subheaderRightM: {
    display: "flex",
    flexDirection: "column",
    columnGap: "16px",
    justifyContent: "center",
    alignItems: "center",
    rowGap: "16px",
  },
  licensePlateD: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
  },
  licensePlateM: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
    marginTop: "16px",
  },
  textNoLicense: {
    fontSize: "14px",
  },
  horizontalWrapperD: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
  },
  horizontalWrapperM: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "24px",
  },
  subWrapperD: {
    width: "50%",
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    justifyContent:'flex-start',
    rowGap:'16px'
  },
  subWrapperM: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    rowGap: "24px",
    marginTop: "24px",
  },

  wrapperLoadDateD: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    columnGap: "16px",
  },
  wrapperLoadDateM: {
    display: "flex",
    flexDirection: "column-reverse",
    width: "100%",
    rowGap: "24px",
  },
};

export const chipsDetails = {
  mainWrapper: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
  },
  wrapperFirstDriver: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    borderColor: "#e9e8e8",
    borderWidth: "1.5px",
    borderRadius: "100px",
    columnGap: "8px",
    maxWidth: "300px",
    height: "40px",
    padding: "0 16px",
  },
  title: {
    fontSize: "10px",
    color: "text.secondary",
  },
  subTitle: {
    fontSize: "14px",
    color: "text.primary",
    fontWeight: "bold",
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderColor: "#e9e8e8",
    borderWidth: "1.5px",
    borderRadius: "100px",
    columnGap: "8px",
    maxWidth: "300px",
    height: "40px",
    padding: "0 16px",
  },
  iconButton: {
    padding: 0,
    margin: 0,
  },
  icon: {
    fontSize: 28,
  },
  popOver: {
    marginTop: "16px",
    marginLeft: "20px",
  },
  popOverBox: {
    padding: "16px",
    borderWidth: "1px",
    borderColor: "primary.main",
    borderRadius: "5px",
  },
  titlePopOver: {
    fontSize: "10px",
    color: "text.secondary",
  },
  subTitlePopOver: {
    fontSize: "16px",
    color: "text.primary",
    fontWeight: "bold",
    marginBottom: "8px",
  },
  buttonPopOver: {
    fontWeight: "bold",
    fontSize: "16px",
    textTransform: "none",
    padding: 0,
    marginBottom: "8px",
    color:"primary.main"
  },
};

export const datesCard = {
  cardD: {
    display: "flex",
    flexDirection: "column",
    width: "70%",
    padding: "24px 16px",
    rowGap: "16px",
  },
  cardM: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "24px 16px",
    rowGap: "16px",
  },
  title: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "primary.main",
  },
  subtitle: {
    marginBottom: "8px",
    fontSize: "11px",
    fontWeight: "bold",
    color: "primary.main",
  },
  box: { marginBottom: "32px" },
  box1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    columnGap: "16px",
    width: "100%",
  },
  box2: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
    alignItems: "center",
    width: "50%",
    justifyContent: "flex-start",
  },
  supportText: {
    fontSize: "12px",
    color: "text.secondary",
  },
  value: {
    fontSize: "14px",
    color: "text.primary",
  },
  status: {
    height: "37px",
    width: "3px",
  },
};

export const documentsCard = {
  card: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "16px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  titleD: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "primary.main",
  },
  titleM: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "primary.main",
    marginBottom: "16px",
  },
  subtitle: {
    fontSize: "12px",
    fontWeight: "bold",
  },
  button: {
    textDecoration: "underline",
    fontWeight: "bold",
    textAlign: "left",
  },
  icon: {
    width: "20px",
    height: "20px",
  },
  mobileWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
};

export const licensePlate = {
  mainWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#f2f2f2",
    borderRadius: "100px",
    columnGap: "8px",
    width: "210px",
    height: "40px",
    justifyContent:'center'
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    gap: "8px 16px",
    height: "40px",
    justifyContent: "space-between",
    width:'100%',
    margin:'0 20px'
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    color: "#555",
  },
  textField: {
    maxWidth: "90px",
    fontSize: "14px",
    "& .MuiOutlinedInput-root": {
      padding: 0,
    },
    "& .MuiInputBase-input": {
      padding: 0,
    },
  },
  iconButton: {
    padding: 0,
    backgroundColor: "primary.main",
    "&:hover": {
      backgroundColor: "#d32f2f",
    },
    color: "white",
  },
  icon: {
    width: "25px",
    height: "25px",
  },
};

export const loadCard = {
  cardD: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "24px 16px",
    rowGap: "16px",
  },
  cardM: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "24px 16px",
    rowGap: "16px",
  },
  title: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "primary.main",
  },
  subtitle: {
    fontSize: "12px",
    color: "text.secondary",
  },
  value: {
    fontSize: "14px",
    color: "text.primary",
  },
};

export const notesCard = {
  card: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "16px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  title: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "primary.main",
  },
  button: {
    fontSize: "12px",
    fontWeight: "bold",
  },
  supportText: {
    fontSize: "12px",
    color: "text.secondary",
    margin: "16px 0 8px 0",
  },
  text: {
    fontSize: "14px",
  },
  mobileWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
  dialog: {
    "& .MuiDialog-paper": {
      maxWidth: "1280px",
      backgroundColor: "#fafafa",
    },
    zIndex:9999
  },
  dialogTitleBox: {
    backgroundColor: "white",
  },
  box: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  text1: {
    textTransform: "capitalize",
    fontWeight: "bold",
    fontSize: "18px",
    color: "primary.main",
  },
  wrapper1: {
    padding: 0,
  },
  listItemTitle: {
    padding: "8px 24px",
  },
  card1: {
    backgroundColor: "white",
    padding: "8px 24px",
    width: "100%",
    boxSizing: "border-box",
  },
};

export const orDestCard = {
  cardD: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    padding: "16px",
    justifyContent: "flex-start",
    alignItems: "center",
    rowGap: "16px",
  },
  cardM: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "16px",
    rowGap: "16px",
  },

  mainWrapper: {
    width: "100%",
  },

  wrapperD: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    columnGap: "16px",
    rowGap: "16px",
  },
  wrapperM: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    columnGap: "16px",
    rowGap: "16px",
  },
  box1D: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
  },
  box1M: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
  },
  title: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "primary.main",
  },
  subtitle: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "text.primary",
  },
  value: {
    fontSize: "14px",
    color: "text.primary",
  },
  button: {
    fontSize: "14px",
    fontWeight: "bold",
    textDecoration: "underline",
    padding: 0,
    marginTop: "16px",
  },
  iconButton: {
    borderRadius: "8px",
    backgroundColor: "primary.main",
    "&:hover": {
      backgroundColor: "#d32f2f",
    },
    color: "white",
  },
  icon: {
    width: "25px",
    height: "25px",
  },
  mobileWrapper: {
    display: "flex",
    flexDirection: "row",
    columnGap: "16px",
  },
};

export const tripDetailsCard = {
  cardD: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transparent",
  },
  cardM: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transparent",
    marginBottom: "16px",
    padding: "0 16px",
  },
  wrapperD: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    columnGap: "16px",
  },
  chipsWrapperD: {
    display: "flex",
    flexDirection: "row",
    columnGap: "16px",
  },
  chipsWrapperM: {
    display: "flex",
    flexDirection: "row",
    columnGap: "16px",
    marginBottom: "8px",
  },
  wrapperM: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    columnGap: "16px",
  },
  tms: {
    fontWeight: "bold",
    fontSize: "24px",
  },
  subWrapper: {
    maxWidth: "160px",
  },
  chip: {
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: "11px",
    maxHeight: "25px",
    maxWidth: "130px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "bold",
  },
  box: {
    display: "flex",
    flexDirection: "row",
    columnGap: "4px",
    alignItems: "center",
    marginTop: "8px",
  },
  acceptanceText: {
    fontSize: "14px",
  },
  acceptanceValue: {
    textDecoration: "underline",
  },
  subWrapper2: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: "10px",
  },
};

export const scrollableBox = {
  wrapper: {
    width: "100%", // Larghezza del contenitore
    height: "auto", // Altezza del contenitore
    overflowX: "auto", // Scrolling orizzontale attivo
    overflowY: "hidden", // Evitare scrolling verticale
    whiteSpace: "nowrap", // Contenuto su una sola linea
    boxSizing: "border-box", // Inclusione padding nei calcoli
    padding: "0 10px",
  },
};

export const timeline = {
  wrapper: {
    width: "100%",
    margin: "8px 8px",
  },
  stepper: {
    "& .MuiStepConnector-line": {
      marginLeft: "3px",
      borderColor: "#4F4C43",
      borderLeftWidth: "3px",
    },
  },
  stepperLabel: {
    borderRadius: "50%",
    backgroundColor: "#4F4C43",
    width: 31,
    height: 31,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  stepperIcon: {
    color: "white",
  },
  box: {
    width: 31,
    height: 31,
    borderRadius: "50%",
    backgroundColor: "#4F4C43",
  },
  box1: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
  },
  box2: {
    paddingLeft: "8px",
  },
  box3: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    columnGap: "8px",
  },
  etichetta: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "primary.main",
  },
  invPartyName: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "text.primary",
  },
  address: {
    fontSize: "14px",
    color: "text.primary",
  },
  mandatoryText: {
    fontSize: "12px",
    fontWeight: "bold",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  },
  mandatoryBox: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
    alignItems: "flex-start",
    justifyContent: "center",
    marginRight: "24px",
  },
  mandatoryTitle: {
    color: "#000",
    fontSize: "16px",
    fontWeight: "bold",
  },
  checkIcon: {
    fontSize: "20px",
  },
  stepContent: {
    padding: 0,
    paddingLeft: "16px",
    marginLeft: "15px",
    borderLeftWidth: "3px",
    borderColor: "#4F4C43",
  },
  card: {
    margin: 0,
    padding: 0,
  },
  cardContent: {
    paddingTop: 0,
    margin: 0,
  },
  chips: {
    mr: 0.5,
    backgroundColor: "#757575",
    textTransform: "uppercase",
    color: "white",
    fontSize: "12px",
  },
};

export const loadsCard = {
  wrapper: {
    mt: 2,
    display: "flex",
    flexDirection: "column",
    rowGap: "16px",
    marginTop: "32px",
  },
  card: {
    p: 1,
    borderColor: "primary.main",
    borderWidth: "1px",
  },
  box: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  iconButton: {
    width: "16px",
    marginLeft: "2px",
  },
  button: {
    fontSize: "14px",
    color: "primary.main",
    textDecoration: "underline",
    fontWeight: "bold",
    padding: 0,
    margin: 0,
  },
  box1: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
    alignItems:'center',
    textTransform:'uppercase'
  },
  loadingPoint: {
    fontSize: "12px",
    color: "#868686",
  },
  loadText: {
    fontSize: "12px",
    color: "text.primary",
    textTransform: "uppercase",
  },
  chips: {
    maxHeight: "19px",
    marginTop: "4px",
    padding: "0",
  },
  labelBox: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
    justifyContent: "center",
    alignItems: "center",
  },
  labelIcon: {
    fontSize: "18px",
    color: "white",
  },
  labelText: {
    fontSize: "12px",
    color: "white",
    textTransform: "uppercase",
  },
  box2: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",

  },
  box3: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: "8px",
  },
  infoIcon: {
    fontSize: "18px",
    color: "primary.main",
  },
  loadsText: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "primary.main",
  },
  text: {
    fontSize: "12px",
    color: "#868686",
  },
  text1: {
    fontSize: "10px",
    color: "text.primary",
    textTransform: "uppercase",
  },
  chips1: {
    backgroundColor: "#DEAF00",
    maxHeight: "19px",
    padding: "0",
  },
  text2: {
    fontSize: "12px",
    color: "white",
    textTransform: "uppercase",
    lineHeight:'0'
  },
  podButton: {
    fontSize: "12px",
    fontWeight: "bold",
  },
};

export const cardDocument = {
  card: {
    width: "360px",
    height:'300px'
    
  },
  box: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "16px",
    height:'100%'
  },
  title: {
    fontSize: "18px",
    fontWeight: "600",
    marginTop: "8px",
  },
  iconButton: {
    padding: 0,
    margin: "16px 0",
  },
  img: {
    width: "36px",
  },
  box1: {
    backgroundColor: "white",
    width: "100%",
    padding: "8px",
    borderRadius: "4px",
  },
  box2: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
    alignItems:'baseline',
  },
  dateText: {
    fontSize: "12px",
    fontWeight: "bold",
  },
  box3: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "white",
    width: "100%",
    justifyContent: "space-between",
    borderRadius: "4px",
    marginTop: "8px",
  },
  iconBox: {
    width: "1px",
    height: "25px",
    backgroundColor: "black",
  },
  box4: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  box5: {
    width: "100%",
  },
  box6: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "white",
    padding: "4px ",
    width: "100%",
    justifyContent: "center",
    borderRadius: "4px",
  },
  underlinedTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    textDecoration: "underline",
    marginTop: "8px",
    cursor:'pointer'
  },
  iconButton1: {
    backgroundColor: "primary.main",
    borderRadius: "8px",
  },
  iconButton2: {
    backgroundColor: "primary.main",
    borderRadius: "8px",
    margin:'24px 0',
    boxShadow:'none',
    width:'40px',
    height:'40px',
  },
  box7: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    backgroundColor: "white",
    padding: "16px ",
    width: "100%",
    justifyContent: "space-between",
    borderRadius: "4px",
  },
  documentButton: {
    width: "1px",
    height: "25px",
    backgroundColor: "black",
  },
};

export const docSide = {
  box: {
    borderWidth: "2px",
    borderRadius: "1rem",
    borderStyle: "dashed",
    borderColor: "#6F6F6F;",
    backgroundColor: "#FFFFFF",
    height:'200px',
    display:'flex',
    alignItems:'center'
  },
  box1: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  title: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "primary.main",
    textTransform:'uppercase'
  },
  box2: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  box3: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    marginTop: "24px",
    width: "100%",
  },
  description: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "primary.main",
    textTransform:'uppercase'
  },
  box4: {
    width: "100%",
    padding: "8px",
  },
  button: {
    fontWeight: "bold",
    height: "36px",
    padding: "0 18px",
  },
  error:{
    color: "red", padding: "0 30px"
  }
};

export const documentPage = {
box:{
   padding: "32px 48px"
},
titlePage:{
   fontWeight: "bold", fontSize: "24px"
},
box1:{
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  columnGap: "4px",
  marginBottom: "32px",
},
subtitle:{
   fontWeight: "bold", fontSize: "16px", color: "primary.main"
},
value:{
  fontWeight: "bold", fontSize: "16px"
},
box2:{
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "16px",
  columnGap: "8px",
  alignItems: "center",
},
box3:{
  display: "flex", columnGap: "8px"
},
iconButton:{
  borderRadius: "4px",
  height: "24px",
  width: "24px",
  padding: 0,
  margin: 0,
},
button:{
  fontWeight: "bold", color: "text.primary", fontSize: "14px"
},
accordion:{
  margin: 0,
  backgroundColor: "transparent",
  padding: 0,

  "&:before": {
    display: "none",
  },
},
summary:{
  backgroundColor: "transparent", padding: 0, margin: 0 
},
textSummary:{
  fontWeight: "bold", color: "primary.main",textTransform:'uppercase'
},
accordionDetails:{
  display: "flex",
  flexDirection: "row",
  columnGap: "16px",
  width:'100%',
  padding:0,
  margin:0,
  
},
box4:{
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "150px",
}
}